var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { classNames } from '../lib-classNames';
import * as React from 'react';
var FormFieldPrivate = /** @class */ (function (_super) {
    __extends(FormFieldPrivate, _super);
    function FormFieldPrivate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormFieldPrivate.prototype.render = function () {
        return (React.createElement("div", { "data-e2e": "cg-field", role: this.getRole(), "aria-labelledby": this.props.ariaLabelledBy || this.props.srLabelledBy, "data-field-inlay-items": this.props.dataFieldInlayItems, className: this.getClass() }, this.props.children));
    };
    FormFieldPrivate.prototype.getAlignment = function () {
        return this.props.groupAlignment || this.props.alignment;
    };
    FormFieldPrivate.prototype.getRole = function () {
        return this.props.isGroup ? 'group' : undefined;
    };
    FormFieldPrivate.prototype.getClass = function () {
        return (classNames({
            'cg-field-small': this.props.size === 'small',
            'cg-field-success': this.props.status === 'success',
            'cg-field-errored': this.props.status === 'error',
            'cg-field-is-disabled': this.props.isDisabled,
            'cg-field-secondary': this.props.mode === 'secondary',
            'cg-field-extra-large': this.props.size === 'extra-large',
            'cg-field-custom-select': this.props.hasSelect,
            'cg-field-textarea': this.props.hasTextarea,
            'cg-field-password': this.props.hasPassword,
            'cg-field-horizontal-choices': this.props.isGroup && this.getAlignment() === 'horizontal',
            'cg-field': true,
        }) +
            ' ' +
            this.props.extraClasses);
    };
    FormFieldPrivate.defaultProps = {
        isGroup: false,
        alignment: 'vertical',
        size: 'large',
        status: 'none',
        errors: [],
        isDisabled: false,
        mode: 'default',
        hasSelect: false,
        hasTextarea: false,
        hasPassword: false,
        extraClasses: '',
    };
    FormFieldPrivate.displayName = 'FormFieldPrivate';
    return FormFieldPrivate;
}(React.Component));
export { FormFieldPrivate };
